import React from "react";
import { Button } from "./Button";

interface AutopilotTypeNotSyncedBlockedProps {
  open: boolean;
  propertyTypeLabel: string | null;
  onClose: () => void;
  onGoToSettings: () => void;
}

// MB-1506: the user tried to manually add one of their own listings while
// Autopilot is on, but its property type is not checked under Property Types
// to Auto-Sync and the listing is not staged in the MLS review lists - so
// nothing brings it in. The MB-1424 dialog ("Autopilot has this covered")
// would be a dead end here, so this one names the type that is switched off
// and walks through the three steps that do add the listing.
const AutopilotTypeNotSyncedBlocked: React.FC<
  AutopilotTypeNotSyncedBlockedProps
> = ({ open, propertyTypeLabel, onClose, onGoToSettings }) => {
  if (!open) return null;

  const typeName = propertyTypeLabel ?? "this property type";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-xl font-bold text-primary mb-4">
          Auto Pilot is not syncing this property type
        </h2>
        <p className="mb-3 text-gray-700 text-sm">
          This is one of your own listings, but {typeName} is not checked under
          Property Types to Auto-Sync, so Auto Pilot will not bring it in.
        </p>
        <p className="mb-2 text-gray-700 text-sm font-semibold">To add it:</p>
        <ol className="mb-5 ml-5 list-decimal space-y-1 text-gray-700 text-sm">
          <li>
            Open Settings &gt; MLS Agent Profile, check it under Property Types
            to Auto-Sync, then save.
          </li>
          <li>Come back to Listings and click Refresh on the MLS bar.</li>
          <li>Click Review and add this listing from the list.</li>
        </ol>
        <div className="flex flex-col gap-2 min-[420px]:flex-row min-[420px]:justify-center">
          <Button onClick={onGoToSettings}>Go to MLS Settings</Button>
          <Button variant="outline" onClick={onClose}>
            Got it
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AutopilotTypeNotSyncedBlocked;
